module.exports = __webpack_public_path__ + "img/eb-l-patricia-02.2c955068.png";